<template>
  <main>
    <h1 class="heading">A Funny Page Not Found Message</h1>
    Sorry for our lack of humour, but this page was not found. Please check the URL then try again.
  </main>
</template>

<script>
  export default {
    name: 'PageNotFound'
  }
</script>